import { FooterText, FooterWrapper } from './FooterElements'

const Footer = () => {
  return (
    <>
      <FooterWrapper>
        <FooterText>© Copyright Naman Parashar 2021.</FooterText>
      </FooterWrapper>
    </>
  )
}

export default Footer
